import { useMutation } from "react-query";

import api from "../../../api";

const loginService = async ({ authData }) => {
  const { email, password } = authData;
  const { data } = await api.post("/auth/token", {
    email,
    password,
  });
  return data;
};

export const useLoginQuery = ({ onSuccess }) => {
  const [mutate, { status, error }] = useMutation(loginService, {
    onSuccess,
  });

  return {
    mutate,
    status,
    error,
  };
};
